import { Notyf } from 'notyf';
import { Customer, Project } from 'static/classes/Accounting';
import { COST_CENTER } from 'static/common/constants';

export function ProjectsViewModel(data) {
	var self = this;
	self.type = "ProjectsViewModel";

	self.rootvm = data.rootvm;

	// constants
	self.COST_CENTER = COST_CENTER;

	self.initialized = ko.observable(false);
	self.initialize = function () {
		self.notfy = new Notyf();
		self.rootvm.is_busy(true);
		self.lookup_customers().then((customers) => {
			self.customers(customers.map(customer => new Customer(customer)));
			self.rootvm.is_busy(false);
		}).catch((error) => {
			self.notfy.error(error);
			console.error(error);
		}).finally(() => {
			self.rootvm.is_busy(false);
		});
		self.lookup_projects().then((projects) => {
			self.projects(projects.map(project => new Project(project)));
			self.rootvm.is_busy(false);
		}).catch((error) => {
			self.notfy.error(error);
			console.error(error);
		}).finally(() => {
			self.rootvm.is_busy(false);
		});
	}

	self.customers = ko.observableArray([]);

	self.new_project = ko.observable(new Project());
	// for editing a existing project
	self.selected_project = ko.observable(new Project());
	self.edit_project = ko.observable(new Project());

	self.projects = ko.observableArray([]);
	/*self.projects.subscribe(() => {
		self.filter_title('')
	});*/

	self.filter_title = ko.observable('');
	self.filtered_projects = ko.pureComputed(() =>
		self.projects().filter((item) => item.title().toLowerCase().includes(self.filter_title().toLowerCase()))
	);


	self.sort_by = ko.observable(undefined);
	self.sort_reverse = ko.observable(false);
	self.sorted_projects = ko.pureComputed(() => {
		let sorted
		switch (self.sort_by()) {
			case 'expenses':
				sorted = self.filtered_projects().sort((a,b) => a.expenses() <= b.expenses() ? 1 : -1)
				break;
			case 'income':
				sorted = self.filtered_projects().sort((a,b) => a.income() <= b.income() ? 1 : -1)
				break;
			case 'profit_margin':
				sorted = self.filtered_projects().sort((a,b) => {
					if (isNaN(a.profit_margin())) return -1
					if (isNaN(b.profit_margin())) return 1
					return a.profit_margin() <= b.profit_margin() ? 1 : -1
				})
				break;
			case 'profit_margin_total':
				sorted = self.filtered_projects().sort((a,b) => {
					if (isNaN(a.profit_margin_total())) return -1
					if (isNaN(b.profit_margin_total())) return 1
					return a.profit_margin_total() <= b.profit_margin_total() ? 1 : -1
				})
				break;
			default:
				sorted = self.filtered_projects().sort((a,b) => a.id() >= b.id() ? 1 : -1)
				break;
		}
		return self.sort_reverse() ? sorted.reverse() : sorted
	});

	self.add_click = function () {
		const url = '/api/admin/project'
		const data = {
			title: self.new_project().title(),
			customer_uuid: self.new_project().new_customer() ? -1 : self.new_project().customer_uuid(),
			customer_name: self.new_project().customer_name(),
			cost_center: self.new_project().cost_center(),
			extra_notes: self.new_project().extra_notes(),
		}
		const request = new Request(url, {
			method: 'POST',
			body: JSON.stringify(data),
			headers: new Headers({
				'Content-Type': 'application/json'
			})
		});

		return fetch(request)
			.then(res => res.json())
			.then(data => {
				if (data.success) {
					data.project.rootvm = self.rootvm;
					if (self.new_project().new_customer()) {
						data.project.customer_name = self.new_project().customer_name();

						self.customers.unshift(new Customer({
							'customer_uuid': data.project.customer_uuid,
							'name': data.project.customer_name
						}));
					} else {
						data.project.customer_name = self.customers().find(c => c.customer_uuid() === self.new_project().customer_uuid()).customer_name();
					}
					self.projects.unshift(new Project(data.project));
					self.new_project(new Project());
					self.notfy.success("Added!");
				} else {
					self.notfy.error(data.message);
					data.pgerror && self.notfy.error('ERROR: ' + data.pgerror);
				}
			})
			.catch(error => {
				self.notfy.error(error);
				console.log(error);
			});
	}

	self.lookup_projects = async () => {
		const response = await fetch(self.rootvm.web_host + '/api/admin/projects', { headers: { 'Accept': 'application/json' }});
		const data = await response.json();
		if (data.success) {
			return data.projects
		} else {
			throw new Error(data.message)
		}
	};
	self.lookup_customers = async () => {
		const response = await fetch(self.rootvm.web_host + '/api/admin/customers', { headers: { 'Accept': 'application/json' }});
		const data = await response.json();
		if (data.success) {
			return data.customers
		} else {
			throw new Error(data.message)
		}
	};

	self.set_selected_project = (project) => {
		data = ko.toJS(project);
		self.selected_project(project);
		self.edit_project(new Project(data));
	}

	self.save_project = () => {
		self.rootvm.is_busy(true);
		return $.ajax({

			url: '/api/admin/edit-project',
			type: 'POST',
			data: ko.toJSON({
				project_uuid: self.edit_project().project_uuid(),
				title: self.edit_project().title(),
				customer_uuid: self.edit_project().customer_uuid(),
				cost_center: self.edit_project().cost_center(),
				extra_notes: self.edit_project().extra_notes()
			}),
			processData: false,
			contentType: "application/json; charset=utf-8",
			success: function (data) {
				if (data.success) {
					self.edit_project().title(self.projects().find((item) => item.project_uuid() === self.edit_project().project_uuid()).title());
					self.projects.replace(self.selected_project(), self.edit_project());
					const editProjectModal = document.getElementById('editProjectModal');
					bootstrap.Modal.getInstance(editProjectModal).hide();
					self.notfy.success("Saved!");
				}
				else {
					self.notfy.error(data.message);
				}
			},
			error: function (jqXHR, errorStatus, thrownError) {
				var response = jQuery.parseJSON(jqXHR.responseText);
				self.notfy.error(response.message);
			},
			complete: () => {
				self.rootvm.is_busy(false);
			}
		})
	}

	self.delete_project = (project) => {
		if (confirm('are you sure you want to delete? ')) {
			self.rootvm.is_busy(true);
			return $.ajax({

				url: '/api/admin/delete-project',
				type: 'POST',
				data: ko.toJSON({
					project_uuid: project.project_uuid(),
				}),
				processData: false,

				contentType: "application/json; charset=utf-8",

				success: function (data) {

					if (data.success) {
						self.projects.remove(project);
						self.notfy.success("Removed!");
					}
					else {
						self.notfy.error(data.message);
					}

				},
				error: function (jqXHR, errorStatus, thrownError) {
					var response = jQuery.parseJSON(jqXHR.responseText);
					self.notfy.error(response.message);
				},
				complete: () => self.rootvm.is_busy(false)
			})
		}
	};
};
